import { render, staticRenderFns } from "./BalanceList.vue?vue&type=template&id=70d25d46&scoped=true"
import script from "./BalanceList.vue?vue&type=script&lang=js"
export * from "./BalanceList.vue?vue&type=script&lang=js"
import style0 from "./BalanceList.vue?vue&type=style&index=0&id=70d25d46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d25d46",
  null
  
)

export default component.exports